"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePesel = void 0;
/**
 * Generuje numer PESEL
 *
 * @export
 * @returns {string}
 */
function generatePesel() {
    const peselBase = `${generateBirthdayPart()}${generateRandomPart()}`;
    const checksum = generateChecksum(peselBase);
    return `${peselBase}${checksum}`;
}
exports.generatePesel = generatePesel;
/**
 * Generuje część z daty urodzin
 *
 * @returns {string}
 */
function generateBirthdayPart() {
    const randomYear = 1950 + Math.floor(Math.random() * 49);
    const randomMonth = Math.floor(Math.random() * 12) + 1;
    const randomDay = Math.floor(Math.random() * 28) + 1;
    return `${randomYear.toString().substring(2)}${randomMonth.toString().padStart(2, '0')}${randomDay
        .toString()
        .padStart(2, '0')}`;
}
/**
 * Generuje część losową
 *
 * @returns {string}
 */
function generateRandomPart() {
    const randomNumber = Math.floor(Math.random() * 10000);
    return randomNumber.toString().padStart(4, '0');
}
const WEIGHTS = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
/**
 * Generuje sumę kontrolną
 *
 * @param {string} peselBase
 * @returns {string}
 */
function generateChecksum(peselBase) {
    const sum = WEIGHTS.reduce((total, weight, index) => total + weight * parseInt(peselBase[index]), 0);
    const magicNumber = sum % 10;
    if (magicNumber === 0) {
        return '0';
    }
    return (10 - magicNumber).toString();
}
//# sourceMappingURL=generatePesel.js.map